<template>
    <vue-multiselect
        ref="select"
        v-bind="$attrs"
        :class="stateClass"
        :internal-search="false"
        label="formatted_string"
        :loading="pending"
        :options="options"
        :placeholder="$t('Please select')"
        :show-labels="false"
        track-by="id"
        :value="value"
        autocomplete="off"
        @search-change="handleSearch"
        @input="$emit('input', $event)"
        @open="handleSearch(null)"
    >
        <div v-if="total" slot="beforeList" class="text-center position-sticky" style="top: 0">
            {{ options.length }} / {{ total }}
        </div>

        <div slot="noOptions">
            {{ $t('Type to search') }}
        </div>

        <div slot="noResult">
            {{ $t('No results found') }}
        </div>

        <template slot="singleLabel" slot-scope="props">
            <span v-html="props.option.formatted_string || props.option.toString" />
        </template>

        <template slot="option" slot-scope="props">
            <span v-html="props.option.formatted_string || props.option.toString" />
        </template>
    </vue-multiselect>
</template>

<script>
    import {formStateMixin} from 'bootstrap-vue/src/mixins/form-state';
    import VueMultiselect from 'vue-multiselect/src/Multiselect';

    export default {
        name: 'WallElement',
        components: {VueMultiselect},
        mixins: [formStateMixin],
        props: {
            projectId: {
                type: [Number, String],
                required: true,
            },
            wallId: {
                type: [Number, String],
                required: true,
            },
            value: {
                type: [Object, Array],
                default: null,
            },
        },
        data() {
            return {
                options: [],
                pending: false,
                total: null
            };
        },
        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/elements`;
            }
        },
        mounted() {
            this.$refs.select.$refs.search.autocomplete = 'off';
        },
        methods: {
            handleSearch(search = null) {
                if (this.timeout) {
                    clearTimeout(this.timeout)
                    this.timeout = null;
                }

                this.timeout = setTimeout(() => this.search(search), 300);
            },

            search(search = null) {

                this.pending = true;

                this.axios.get(this.apiUrl, {
                    params: {search}
                }).then(({data}) => {
                    this.options = data.data || data;
                    this.total = data.total;

                }).catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                }).finally(() => {
                    this.pending = false;
                })
            }
        },
    };
</script>
